// Tags de mídia no front: chip do TagInput ↔ tag da API. Funções puras.
import type { MediaAssetTag, MediaTag, MediaTagAssignment } from '@/types/media';

/** Tag escolhida: existente (`tag_id`) ou nova (só nome + categoria; o backend cria ao salvar). */
export interface TagChip {
  tag_id?: number;
  category_id: number;
  category_name: string;
  name: string;
  source?: 'ai' | 'user';
}

export const sameTag = (a: TagChip, b: TagChip): boolean =>
  a.tag_id && b.tag_id
    ? a.tag_id === b.tag_id
    : a.category_id === b.category_id && a.name.trim().toLowerCase() === b.name.trim().toLowerCase();

export const chipFromTag = (t: MediaTag): TagChip => ({
  tag_id: t.id,
  category_id: t.category_id,
  category_name: t.category_name,
  name: t.name,
});

export const chipFromAssetTag = (t: MediaAssetTag): TagChip => ({
  tag_id: t.tag_id,
  category_id: t.category_id,
  category_name: t.category_name,
  name: t.name,
  source: t.source,
});

/** Chips → corpo do PUT /media/:id/tags (`{ tag_id }` ou `{ category_id, name }`). */
export const chipsToAssignments = (chips: TagChip[]): MediaTagAssignment[] =>
  chips.map((c) => (c.tag_id ? { tag_id: c.tag_id } : { category_id: c.category_id, name: c.name.trim() }));
